import layout from './layout';
import font from './font';
import colors from './colors';
import transitions from './transitions';
import shadows from './shadows';
import tokens from './tokens';

export default { layout, font, colors, transitions, shadows, tokens };
